<template>
  <section aria-labelledby="history-title">
    <Card>
      <CardHeader>
        <CardTitle id="history-title">History</CardTitle>
      </CardHeader>
      <CardContent>
        <HFetchQuery :query="historyQuery">
          <template #default="{ data }">
            <SimpleRecordList
              :columns="['updated by', 'field changed', 'from', 'to', 'updated at']"
              :records="parseHistory(data)"
            />
          </template>
        </HFetchQuery>
      </CardContent>
    </Card>
  </section>
</template>

<script setup lang="ts">
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import SimpleRecordList from '../shared/SimpleRecordList.vue';
import HFetchQuery from '@/lib/hfetch/HFetchQuery.vue';
import { useHFetchQuery } from '@/lib/hfetch/useHFetchQuery';
import { Api } from '@/api';
import DateUtility from '../../utilities/dates';
import type { ContactHistoryVersion } from '@/api/contacts';

const props = defineProps<{ contactId: string | number }>();

type HistoryRow = {
  'updated by': string;
  'field changed': string;
  from: unknown;
  to: unknown;
  'updated at': string | null;
};

const historyQuery = useHFetchQuery(() => Api.Contacts.getContactHistory(props.contactId));

const formatDate = (val: string | undefined) => {
  if (!val) return null;
  return DateUtility.formatDate(val, 'MMMM dd yyyy, h:mm a');
};

const parseHistory = (versions: ContactHistoryVersion[]): HistoryRow[] => {
  const rows: HistoryRow[] = [];
  for (const version of versions) {
    const changes = version.version.object_changes;
    if (!changes) continue;
    for (const key of Object.keys(changes)) {
      if (key === 'updated_at') continue;
      rows.push({
        'updated by': version.whodunnit,
        'field changed': key.replace(/_/g, ' '),
        from: changes[key][0],
        to: changes[key][1],
        'updated at': formatDate(version.version.created_at),
      });
    }
  }
  return rows;
};
</script>
